import { Component, Input } from '@angular/core';
import { Highlights } from '../../Highlights';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
type FFHUnicornTierOne = {
  fortune500: string[];
  unicorn: string[];
  tierOneSchools: string[];
};

@Component({
  selector: 'app-hire-slider-profile-view',
  imports: [CommonModule, NgbTooltipModule],
  templateUrl: './hire-slider-profile-view.component.html',
  styleUrl: './hire-slider-profile-view.component.scss',
  standalone: true
})
export class HireSliderProfileViewComponent {

  @Input() candidate: any;
  @Input() calledFrom: string = '';
  highlightsList: any[] = [];
  highlightsPillData = new Highlights();
  highlights: MatchHighlights;
  hasSomeFilter: boolean = false;

  ngOnInit() {

    this.setHighlightsData();
    this.updateVisibleHighlights();
    this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.candidate?.curatedtalentpooltags);
  }


 private getTierOneCompanyAndSchoolHilights(curatedtalentpooltags: any[]) {
    const highlightsFormatedData: any[] = [];
      const grouped: Record<string, any> = {};

    if (this.highlightsPillData.fetchTalentIndustries && this.highlightsPillData.fetchTalentIndustries.length) {
      grouped['fetchTalentIndustries'] = { label: "Multi-Industry", value: this.highlightsPillData.fetchTalentIndustries, color: "blue", imageName: "multi-industry" }
    }

    if (this.highlightsPillData.fetchUnicornCompanies && this.highlightsPillData.fetchUnicornCompanies.length) {
      grouped['fetchUnicornCompanies'] = { label: "Unicorn Experience", value: this.highlightsPillData.fetchUnicornCompanies, color: "yellow", imageName: "unicorn-experience" }
    }

    if (this.highlightsPillData?.isTechie) {
      grouped['isTechie'] = { label: "Techie", value: this.highlightsPillData.isTechie, color: "green", imageName: "techie" }
    }

    if (this.candidate?.currentjob_internal_movement || this.candidate?.progression_within_pastcompany) {
      grouped['PromotionTrack'] = { label: "Promotion Track", value: { currentjob_internal_movement: this.candidate?.currentjob_internal_movement, progression_within_pastcompany: this.candidate?.progression_within_pastcompany }, color: "yellow", imageName: "promotion-track" }
    }

    const displayNameConfig: any = {
      "maang": { label: "MAANG", color: "maang", imageName: "maang" },
      "dax 40": { label: "DAX 40", color: "dax", imageName: "dax40" },
      "nasdaq 100": { label: "NASDAQ 100", color: "nasdaq", imageName: "nasdaq100" },
      "nifty 50 / sensex": { label: "Nifty 50 / Sensex", color: "nifty", imageName: "nifty50" },
      "fortune-500 us": { label: "Fortune Global 500", color: "fortuneGlobal", imageName: "fortuneglobal500" },
      "s&p 500": { label: "S&P 500", color: "sp", imageName: "sp500" },
      "big four": { label: "Big 4", color: "bigfour", imageName: "big4" },
      "dow 30": { label: "DOW 30", color: "dow", imageName: "dow30" },
      "fortune-500": { label: "Fortune 500", color: "fortune", imageName: "fortune500" },
      "big oil": { label: "Big Oil", color: "bigoil", imageName: "bigoil" },
      "ftse 100": { label: "FTSE 100", color: "ftse", imageName: "ftse100" },
      "u15 group (canada)": { label: "U15 Group (Canada)", color: "u15group", imageName: "u15" },
      "batx": { label: "BATX", color: "batx", imageName: "batx" },

      "tier-1 school": { label: "Tier-1 School", color: "teal", imageName: "tier1school" },
      "c9 league (china)": { label: "C9 League (China)", color: "c9League", imageName: "c9" },
      "ivy league (usa)": { label: "Ivy League (USA)", color: "ivy", imageName: "ivy" },
      "group of eight (australia)": { label: "Group of Eight (Australia)", color: "navy", imageName: "go8" },
      "russell group (uk)": { label: "Russell Group (UK)", color: "groupOfEight", imageName: "russell" },
    };


  if(curatedtalentpooltags && curatedtalentpooltags?.length){
    for (let el of curatedtalentpooltags) {
      if (!el?.displayname || !el?.name) continue;

      const key = el.displayname.toLowerCase().trim();
      const config = displayNameConfig[key];
      if (!config) continue;

      if (!grouped[key]) {
        grouped[key] = {
          id: Object.keys(grouped).length + 1,
          label: config.label,
          value: [],
          color: config.color,
          imageName: config.imageName
        };
      }

      if (!grouped[key].value.includes(el.name)) {
        grouped[key].value.push(el.name);
      }
    }
  }

    return Object.values(grouped);
  }

  highlightInfo(data: string) {

    if (data) {
      const dataForHighlight = data?.trim().toLowerCase().replace(/<.*?>/g, '').replace(/'/g, "");
      let highlightedData = data;

      if (this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.summary']) {
        const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
        highlightFound && (highlightedData = highlightFound);
      } if (this.candidate && this.candidate?.highlight && this.candidate?.highlight['summary']) {
        const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
        highlightFound && (highlightedData = highlightFound);
      }
      return highlightedData;

    }


    return data;
  }



  /**
 *
 * Intialises all the fields necessary for showing candidate highlights
 *
 */
  private setHighlightsData() {
    this.highlightsPillData.setTechie(this.isCandidateTechie(this.candidate));
    this.highlightsPillData.setTalentIndustries(this.getTalentIndustries(this.candidate?.experience));
    const extraHighlightsDetails = this.getFFHUnicornAndTierOne(this.candidate?.curatedtalentpooltags);
    this.highlightsPillData.setUnicornCompanies(extraHighlightsDetails.unicorn);
    this.highlightsPillData.setFortuneFH(extraHighlightsDetails.fortune500);
    this.highlightsPillData.setTierOneSchools(extraHighlightsDetails.tierOneSchools);
  }

  isCandidateTechie(data: any): boolean {
    let isTechie = false;
    if (!!data.profiles && !!data.profiles.length) {
      isTechie = data.profiles.some(item => item.network == "stackoverflow");
    }
    isTechie = isTechie || !!data.github_url;
    return isTechie;
  }

  getTalentIndustries(experiences: any[]): any {

    let industries: { name: string; exp: {}; }[] = [];

    experiences.forEach(el => {
      if (!!el?.company?.industry)
        industries.push({
          name: el?.company?.industry,
          exp: this.getExperience(el)
        });
    });
    // industries = _.uniq(industries, x => x.name);

    let data = this.getUniqueIndustries(industries)
    return data;
  }

  getUniqueIndustries(industries) {
    const uniqueData = this.uniqueExperience(industries);
    return uniqueData;

  }


  uniqueExperience(data) {
    const result = {};

    for (const item of data) {
      const key = `${item.name}`;

      if (result[key]) {
        if (item.exp.start_date == result[key].exp.start_date) {
          result[key].exp.year = item.exp.year;
          result[key].exp.month = item.exp.month;
        } else {
          result[key].exp.year += item.exp.year;
          result[key].exp.month += item.exp.month;

          while (result[key].exp.month >= 12) {
            result[key].exp.year += 1;
            result[key].exp.month -= 12;
          }
        }
      } else {
        result[key] = {
          name: item.name,
          exp: { year: item.exp.year, month: item.exp.month, start_date: item.exp.start_date }
        };
      }
    }

    const uniqueAggregatedData = Object.values(result);
    return uniqueAggregatedData;
  }

  getExperience(obj: any) {

    let exp = {}

    if (obj.start_date && obj.end_date !== null && obj.start_date !== null) {

      let startDate = obj.start_date;
      let endDate = obj.end_date;

      const startDateArray = startDate.split("-");
      const endDateArray = endDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }

      exp = { year: yearDiff, month: monthDiff, start_date: startDate }

    } else {

      if (obj.start_date !== null) {
        let startDate = obj.start_date;
        const formattedDate = new Date();
        const year = formattedDate.getFullYear();
        const month = formattedDate.getMonth() + 1;
        const currentDate = `${year}-${month}`;

        const startDateArray = startDate.split("-");
        const endDateArray = currentDate.split("-");

        const startYear = parseInt(startDateArray[0], 10);
        const startMonth = parseInt(startDateArray[1], 10);
        const endYear = parseInt(endDateArray[0], 10);
        const endMonth = parseInt(endDateArray[1], 10);

        let yearDiff = endYear - startYear;
        let monthDiff = endMonth - startMonth;

        if (monthDiff < 0) {
          yearDiff--;
          monthDiff += 12;
        }
        exp = { year: yearDiff, month: monthDiff, start_date: startDate }
      }
    }

    return exp;
  }

  /**
   *
   * @returns An object with list of fortune five hundred, unicorn experience, and tier 1 school experience details.
   *
   */
  private getFFHUnicornAndTierOne(curatedtalentpooltags): FFHUnicornTierOne {
    const res = {
      fortune500: [],
      unicorn: [],
      tierOneSchools: []
    };
    if (!curatedtalentpooltags)
      return res;
    for (let el of curatedtalentpooltags) {
      if (el?.type === "experience" && el?.displayname?.toLowerCase() === "fortune-500" && !!el?.name) { res.fortune500.push(el?.name); }
      else if (el?.type === "experience" && el?.displayname?.toLowerCase() === "unicorns" && !!el?.name) { res.unicorn.push(el?.name); }
      else if (el?.type === "education" && el?.displayname?.toLowerCase() === "tier-1 school" && !!el?.name) { res.tierOneSchools.push(el?.name); }
    }
    res.fortune500 = [...new Set(res.fortune500)];
    res.unicorn = [...new Set(res.unicorn)];
    res.tierOneSchools = [...new Set(res.tierOneSchools)];
    return res;
  }

  private updateVisibleHighlights() {
    let highlightsCount = 0;
    if (this.highlightsPillData.fetchUnicornCompanies?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchFortuneFH?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchTierOneSchools?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.isTechie) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }

    if (this.highlightsPillData.fetchTalentIndustries?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlightsPillData.fetchTalentIndustries?.length) {
      this.highlightsPillData.setTalentIndustries([]);
    }

    if (this.highlights?.regionname?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.regionname?.length) {
      this.highlights.regionname = null;
    }

    if (this.highlights?.companySizes?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.companySizes?.length) {
      this.highlights.companySizes = null;
    }

    if (this.highlights?.totalTenure?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.totalTenure?.length) {
      this.highlights.totalTenure = null;
    }

    if (this.highlights?.skills?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.skills?.length) {
      this.highlights.skills = null;
    }

    if (this.highlights?.titles?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.titles?.length) {
      this.highlights.titles = null;
    }

    if (this.highlights?.locationNames?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlights?.locationNames?.length) {
      this.highlights.locationNames = null;
    }

  }

}
